import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batches: string[];
}

export const useUnarchiveBatches = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batches }: HookProps) => {
      await request({
        path: `batches/unarchive-batches`,
        method: 'POST',
        authenticate: true,
        dataObject: { batches },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully unarchived batches!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error unarchiving batches!');
    },
  });
};
